import {SET_FONT_SIZE} from '../constants/ActionTypes';

const initialState = {
    size: 'normal'
};

export default function font(state = initialState, action) {
    switch (action.type) {
        case SET_FONT_SIZE:
            return {
                ...state,
                size: action.size
            };
        default:
          return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/font.js